import {
  Box,
  FormControl,
  FormHelperText,
  MenuItem,
  Select,
  Typography
} from '@mui/material';
import { FieldInputProps, FormikProps } from 'formik';
import { JSX } from 'react';

const countryCodes = [
  { code: '+971', short: 'AE' },
  { code: '+966', short: 'SA' },
  { code: '+965', short: 'KW' },
  { code: '+973', short: 'BH' },
  { code: '+974', short: 'QA' },
  { code: '+968', short: 'OM' },
  { code: '+20', short: 'EG' },
  { code: '+962', short: 'JO' },
  { code: '+961', short: 'LB' },
  { code: '+964', short: 'IQ' },
  { code: '+92', short: 'PK' },
];


// type CountryCode = {
//   code: string | number;
//   short: string;
// };

type PhoneNumberInputProps<T extends string | number = string> = {
  field: FieldInputProps<T>;
  form: FormikProps<any>;
  selectedCountryCode?: string | number;
  onCountryCodeChange: (code: string) => void;
};

const PhoneNumberInput = <T extends string | number>({
  field,
  form,
  selectedCountryCode,
  onCountryCodeChange
}: PhoneNumberInputProps<T>): JSX.Element => {

  return (
    <FormControl
      fullWidth
      error={Boolean(form.touched[field.name] && form.errors[field.name])}
    >
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
        <Select
          value={selectedCountryCode}
          onChange={(e) => {
            const newCode = e.target.value;
            onCountryCodeChange(String(newCode));
            if (field.value) {
              form.setFieldValue(field.name, field.value);
            }
          }}
          sx={{
            width: '120px',
            '& .MuiSelect-select': { padding: '8px' }
          }}
        >
          {countryCodes.map((cc) => (
            <MenuItem key={cc.code} value={cc.code}>
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                <Box sx={{ width: 28, display: 'flex', justifyContent: 'center' }}>
                  <img
                    src={`https://flagcdn.com/w40/${cc.short.toLowerCase()}.png`}
                    alt={cc.short}
                    style={{ width: 24, height: 16, objectFit: 'cover', borderRadius: 2 }}
                  />
                </Box>
                <Typography sx={{ fontSize: '15px' }}>{cc.code}</Typography>
              </Box>
            </MenuItem>


          ))}
        </Select>

        <input
          {...field}
          type="text"
          value={field.value ?? ''}
          maxLength={10}
          style={{
            flex: 1,
            width: '255px',
            padding: '8px',
            borderRadius: '4px',
            border: '1px solid #ccc'
          }}
          onChange={(e) => {
            const onlyNumbers = e.target.value.replace(/[^0-9]/g, '');
            form.setFieldValue(field.name, onlyNumbers);
          }}
        />
      </Box>

      {form.touched[field.name] && form.errors[field.name] && (
        <FormHelperText>
          {form.errors[field.name] as string}
        </FormHelperText>
      )}
    </FormControl>
  );
};

export default PhoneNumberInput;
